<template>
	<div class="contractList">
		<div class="filters">
			<el-form :inline="true" :model="form">
				<!-- 合同编号input -->
				<el-form-item>
					<el-input placeholder="请输入合同编号" v-model="form.contractNum"></el-input>
				</el-form-item>
				<!-- 合同名称input -->
				<el-form-item>
					<el-input placeholder="请输入合同名称" v-model="form.contractName"></el-input>
				</el-form-item>
				<!-- 名称input -->
				<el-form-item>
					<el-date-picker @change="changeDate" v-model="form.date" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp">
					</el-date-picker>
				</el-form-item>
				<!-- 合同状态 -->
				<el-form-item>
					<el-select v-model="form.contractState">
						<el-option key label="请选择合同状态" value=""></el-option>
						<el-option v-for="(item,index) in contractStateList" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<div>
			<el-card>
				<el-button type="primary" slot="header" @click="add()">新增合同</el-button>
				<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
					@selection-change="handleSelectionChange"
					:height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
					<el-table-column type="selection" width="55" v-if="venueManagecheckbox"></el-table-column>
					<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
					</el-table-column>
					<el-table-column prop="contractNum" label="合同编号">
					</el-table-column>
					<el-table-column prop="contractName" label="合同名称">
					</el-table-column>
					<el-table-column prop="contractPrice" label="合同金额">
					</el-table-column>
					<el-table-column prop="startDate" label="合同生效日期">
						<template slot-scope="scope">
							{{scope.row.startDate | timeYMD }}
						</template>
					</el-table-column>
					<el-table-column prop="endDate" label="合同截止日期">
						<template slot-scope="scope">
							{{scope.row.endDate | timeYMD }}
						</template>
					</el-table-column>
					<el-table-column prop="contractState" label="合同状态">
						<template slot-scope="scope">
							<span v-if="scope.row.contractState == 1">正常</span>
							<span v-if="scope.row.contractState == 2" style="color:red">已过期</span>
							<span v-if="scope.row.contractState == 3" style="color:red">已关闭</span>
						</template>
					</el-table-column>
					<el-table-column prop="contractFileState" label="合同归档状态">
						<template slot-scope="scope">
							<span v-if="scope.row.contractFileState == 1">已归档</span>
							<span v-if="scope.row.contractFileState == 2">未归档</span>
						</template>
					</el-table-column>
					<el-table-column prop="contractSupplierInfo.supplierName" label="关联供应商">
					</el-table-column>
					<el-table-column prop="filesList" label="合同文件">
						<template slot-scope="scope">
							<viewer v-if="scope.row.filesList!=''" :images="scope.row.filesList" class="img-width">
								<img v-for="(src,index) in scope.row.filesList" :src="src" :key="index" class="img" />
							</viewer>
						</template>
					</el-table-column>
					<el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width3">
						<template slot-scope="scope">
							<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
							<el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
					:page-count="pageCount" />
			</el-card>
		</div>
	</div>
</template>

<script>
	export default {
		name: '/manage/main.venueList',
		data() {
			return {
				pageCount: 0, // 总页数
				pageNo: 1, // 页数
				pageSize: 10, // 每页显示数量
				multipleSelection: [], // 多选框
				venueManagecheckbox: require('@/config/enum').venueManagecheckbox, // 是否隐藏复选框
				tableData: [], // 列表数据
				form: {
					contractNum: '',
					contractName: '',
					date: [],
					startDate: '',
					endDate: '',
					contractState: '',
				},
				contractStateList: [
					{
						id: '1',
						name: '正常'
					},
					{
						id: '2',
						name: '已过期'
					},
					{
						id: '3',
						name: '已关闭'
					}
				]
			}
		},
		watch: {

		},
		created() {
			this.getData()
		},
		activated() {
			this.getData()
		},
		methods: {
			// 修改日期（模糊查询）
			changeDate(e) {
				console.log(e)
				if (e) {
					this.form.date = e
					this.form.startDate = e[0]
					this.form.endDate = e[1]
				} else {
					this.form.date = []
					this.form.startDate = ''
					this.form.endDate = ''
				}
			},
			// 获取列表数据
			getData() {
				let loading = this.$loading()
				let url =
					`/venueContract?pageSize=${this.pageSize}&pageNo=${this.pageNo}&contractNum=${this.form.contractNum}&contractName=${this.form.contractName}&startDate=${this.form.startDate}&endDate=${this.form.endDate}&contractState=${this.form.contractState}&gardenId=${this.$store.getters.gardenId}`
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.tableData = res.list
							for (var i = 0; i < this.tableData.length; i++) {
								if(this.tableData[i].filesList){
									var a = this.tableData[i].filesList.split(',')
									this.tableData[i].filesList = a
								}
							}

							console.log(this.tableData)
							this.pageCount = res.pageCount
							console.log(this.pageCount)
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			// 新增
			add() {
				window.localStorage.setItem('contractForm', '')
				this.$router.push({
					name: 'contractAdd',
					query: {
						flag: true
					}
				})
			},
			// 编辑
			edit(rowData) {
				window.localStorage.setItem('contractForm', '')
				this.$router.push({
					name: 'contractAdd',
					query: {
						flag: false,
						object: rowData,
					}
				})
			},
			// 删除
			deleteOne(id) {
				let loading = this.$loading()
				this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						cancelButtonText: this.$i18n.t('lang.btn_cancel'),
						type: 'warning'
					}).then(() => {
						this.$delete(`/venueContract/` + id).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			},
			// 更新
			commit() {
				this.pageNo = 1
				this.getData()
			},
			// 表格斑马
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// 多选框
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getData()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getData()
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},

		}
	}
</script>

<style lang="scss">
	.contractList {
		.img-width {
			overflow: hidden !important;
			text-overflow: ellipsis !important;
			white-space: nowrap !important;
			max-width: 320px;
		}

		.img {
			width: 80px;
			height: 50px;
			border: 1px solid lightgray;
			border-radius: 5px;
			padding: 5px;
		}
	}
</style>